export const MESSAGING_API_LEGACY_VERSION = '2021-06-10';
// First version that allows conversation show and contacts create.
export const MESSAGING_API_CONTACTS_CREATE_VERSION = '2026-04-14';
export const MESSAGING_API_LATEST_VERSION = '2026-05-26';

export const MESSAGING_CLIENT_ELEMENT_ID = 'ember-messaging-client';

// Legacy sentinel: a system message marking where older history was hidden. It was only used once,
// when minors and couples were added, and nothing in live code creates it today. Older history is
// only available through the Practice Data Export. The beginning banner hides when it is loaded.
export const CONVERSATION_TRUNCATED_MESSAGE = 'CONVERSATION_TRUNCATED';

/** Conversation history visibility for newly added members (`meta.history_mode`). */
export const HISTORY_MODE = {
  FULL: 'full',
  NEW_ONLY: 'new_only',
};

export const MODEL_NAMES = {
  CONTACT: 'messaging-contact',
  CONVERSATION: 'messaging-conversation',
  MESSAGE: 'messaging-message',
  PROFILE: 'messaging-profile',
  SYSTEM_USER: 'messaging-system-user',
  USER: 'messaging-user',
};
